/**Dependencies */
import React from "react";

/**Components */
import { BannerParallax } from "../components/BannerParallax";
import { BannerDudas } from "../components/BannerDudas";
import { Row, Col } from "react-bootstrap";

/**Images */
import bannerCircuitos from "../images2/bannerCircuitos.png";
import parallaxCircuitos from "../images2/parallax-circuitos.png";
import BannerNecesitasAyuda from "../images2/Necesitas-ayuda.png";
import BannerNecesitasAyudaMovil from "../images2/Necesitas-ayuda-Movil.png";

export const Circuitos = () => {
  return (
    <div>
      <div className="mb-5">
        <Row className="justify-content-lg-end justify-content-center m-0">
          <Col lg={12} sm={12} className="d-lg-grid align-items-center p-0">
            <div className="position-relative">
              <img
                className="w-100 shadow rounded-5 object-fit-cover"
                src={bannerCircuitos}
                height={500}
                alt=""
              />
              <div
                className="position-absolute"
                style={{
                  transform: "translate(-50%, -50%)",
                  top: "50%",
                  left: "47%",
                }}
              >
                <h1 style={{ color: "#fff", fontSize: "50px" }}>
                  Las mejores experiencias en cada destino
                </h1>
                <p className="text-light" style={{ fontSize: "25px" }}>
                  Tours culturales y gastronómicos hasta deportes extremos y
                  aventuras en el aire.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="container">
        <h1 className="text-center py-0 py-sm-0 py-lg-5">
          Aquí comienza tu viaje
        </h1>
        <iframe
          title="megatravel"
          src="https://www.megatravel.com.mx/tools/ofertas-viaje.php?Dest=&amp;txtColor=6E6E6E&amp;lblTPaq=A812BA&amp;lblTRange=A812BA&amp;lblNumRange=3300FF&amp;itemBack=009e99&amp;ItemHov=A4FF06&amp;txtColorHov=6E6E6E&amp;ff=1"
          width="100%"
          height="700"
        ></iframe>
      </div>
      <div className="py-5">
        <BannerParallax
          img={parallaxCircuitos}
          title={"Siente la libertad de viajar"}
          subtitle={
            "Descubre las maravillas de cada continente en la mejor época del año"
          }
        />
      </div>
      <div className="py-5">
        <BannerDudas
          imgDudasDesk={BannerNecesitasAyuda}
          imgDudasMovil={BannerNecesitasAyudaMovil}
          bannerDudas={false}
        />
      </div>
    </div>
  );
};
